// extracted by mini-css-extract-plugin
export default {"time":"styles_time__VqCwy","green":"styles_green__K8oAm","red":"styles_red__8rFUI"};